import * as React from 'react'
import { render as ReactDOMRender } from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import * as E from 'fp-ts/lib/Either'

import { getEnvironment } from '@espoon-voltti/nuora-app-common/config'

import { App } from './app'
import { configs } from './config'
import { uiRootUrl } from './session'
import * as api from './services/api'
import * as errorHandling from './error-handling'

const maybeEnv = getEnvironment()

if (E.isRight(maybeEnv)) {
  const config = configs[maybeEnv.right]

  api.init()
  errorHandling.init(maybeEnv.right, config.sentry)

  ReactDOMRender(
    <BrowserRouter basename={uiRootUrl}>
      <App />
    </BrowserRouter>,
    document.getElementById('root') as HTMLElement
  )
} else {
  console.error('Ambiguous env', maybeEnv.left, 'application start ABORTED')
}
